import { modalErrorReducer, State as ModalErrorState } from '@/shared/modal-error/duck/reducer';
import { pageErrorReducer, State as PageErrorState } from '@/views/auth-failure/duck/reducer';
import { reducer as flowStatesTooltipReducer, State as FlowStatesTooltipState } from './flow-states-tooltip/reducer';
import { reducer as loginReducer, State as LoginState } from './login/reducer';
import { modalReducer, State as ModalState } from './modal/reducers';
import { pageLoaderReducer, State as PageLoaderState } from './page-loader/reducer';

export const rootReducer = {
  modal: modalReducer,
  modalError: modalErrorReducer,
  login: loginReducer,
  pageLoadingAnimation: pageLoaderReducer,
  pageError: pageErrorReducer,
  flowStatesTooltip: flowStatesTooltipReducer,
};

export type StoreState = {
  modal: ModalState,
  login: LoginState,
  pageLoadingAnimation: PageLoaderState,
  modalError: ModalErrorState,
  pageError: PageErrorState,
  flowStatesTooltip: FlowStatesTooltipState,
};
